<template>
  <div id="app">
    <cHeadbar id="headbar" v-if="!withoutTopBar && hasHeadbar"></cHeadbar>
    <cAttention></cAttention>
    <router-view id="wrap" :class="{ withTopBar: !withoutTopBar && hasHeadbar }" :style="!$from ? '' : 'top:0'"></router-view>
    <cLoading id="loading" v-if="loading"></cLoading>
    <cBack v-if="!needBack"></cBack>
    <!-- lg-preview-->
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { loadQiyuSdk } from '@/utils/qiyu'
import kunhuaPhysicalRoutes from '@/router/modules/kunhuaPhysicalExamination'

const kunhuaPhysicalPaths = kunhuaPhysicalRoutes.map(route => route.path)

export default {
  data() {
    return {
      withoutTopBar: false,
      from: '',
      needBack: false,
      scriptLoaded: false,
      hasHeadbar: true
    }
  },
  created() {
    if (this.$userDetail) {
      if (this.$userDetail.phone_number.indexOf('$') > -1) {
        this.$router.push('/bind_mobile')
      }
    }
    // this.$router.push('/notice')
    if (localStorage.getItem('authtoken')) {
      this.hasHeadbar = true
    } else {
      this.hasHeadbar = false
    }

    const isMiniProgram = localStorage.getItem('is_wx') === '1'
    if (
      (navigator.userAgent.indexOf('MicroMessenger') < 0 &&
        (navigator.userAgent.indexOf('Alipay') < 0 || navigator.userAgent.indexOf('AlipayClient') < 0)) ||
      isMiniProgram
    ) {
      this.hasHeadbar = false
      this.withoutTopBar = true
    }
    // if (this.$route.query.result && this.$route.query.result == 'USER_REGISTER_SUCCESS') {
    //   setTimeout(() => {
    //     this.$toast('注册成功')
    //   }, 1000)
    // }
  },
  async mounted() {
    this.load()
    this.checkQiyu()
    // this.redirectPath()
    await this.initRouteMap()
  },
  methods: {
    ...mapActions(['loadUserData', 'initRouteMap']),
    load() {
      const uuid = this.utils.genUUID(32, 16)
      sessionStorage.setItem('uuid', uuid)
      this.loadUserData()
    },
    checkQiyu() {
      // 因为这部分页面需要加载到昆华医院的小程序中，客服插件导致了昆华小程序无法正常加载
      // 定义不需要加载客服的路由路径，支持部分匹配
      
      // 昆华医院不需要加载客服的路由路径（报告相关）
      const reportPaths = [
        '/',
        '/report_query_kunhua',
        '/report_list_kunhua',
        '/report_pdf_kunhua',
        '/report_detail_kunhua',
        '/report_pdf_kunhua_download'
      ]
      
      // 合并：报告路由 + 昆华体检所有路由
      const excludePaths = [...reportPaths, ...kunhuaPhysicalPaths]
      
      // 如果当前路径不在排除列表中，则加载SDK
      const shouldLoad = !excludePaths.some(p => this.path === p)
      
      if (shouldLoad) {
        loadQiyuSdk()
      }
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.app.onLoading,
      path: (state) => state.route.path
    })
  },
  watch: {
    path() {
      this.checkQiyu()
      // 隐藏顶部导航的常规路由列表
      const noTopBarPaths = [
        '/',
        '/home',
        '/ucenter',
        '/home_new',
        '/ucenter_new',
        '/lead_attention',
        '/user_regiter',
        '/Identity_verification',
        'confirm_change_bingding',
        'change_binding',
        '/news',
        '/yunnancn',
        '/ucenter_protocol',
        '/yunnancn_home',
        '/ynPhysical',
        '/ynOnline',
        '/ynReport',
        '/ynfree',
        '/ynCommunity',
        '/spine',
        '/spine_center',
        '/registration_hospital_list_new',
        '/notice',
        '/redirect/promotion',
        '/redirect/promotion_mp',
        '/payCallback',
        '/TijianpayCallback',
        '/wechat/order-ticket',
        '/ai_guidance',
        '/kunhua_unit_pe_add_package',
        '/kunhua_unit_pe_login',
        '/report_query_kunhua',
        '/report_list_kunhua',
        '/report_pdf_kunhua',
        '/report_detail_kunhua',
        '/report_pdf_kunhua_download'
      ]

      // 合并常规无顶部导航路由 + 昆华体检所有路由
      const allNoTopBarPaths = [...noTopBarPaths, ...kunhuaPhysicalPaths]

      this.withoutTopBar = allNoTopBarPaths.indexOf(this.path) >= 0
      this.needBack =
        [
          '/',
          '/home',
          '/home_new',
          '/ucenter_new',
          '/ucenter',
          '/news',
          '/Identity_verification',
          '/ucenter_appointment_order_details',
          '/ask_question_chat',
          '/physicalExamination_new_detail',
          '/adviserOrderPayDetail',
          '/change_binding',
          '/confirm_change_bingding',
          '/user_regiter',
          '/notice',
          '/redirect/promotion',
          '/redirect/promotion_mp',
          '/payCallback',
          '/TijianpayCallback',
          '/ucenter_register_records_pay',
          '/ucenter_register_records_detail',
          '/wechat/order-ticket',
          '/ai_guidance',
          '/kunhua_unit_pe_add_package',
          '/kunhua_unit_pe_login'
        ].indexOf(this.path) >= 0
    }
  }
}
</script>

<style lang="less">
@import './styles/base.less';

html,
body,
#app {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: absolute;
}

#headbar,
#wrap,
#loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

#headbar {
  z-index: 100;
}

#wrap,
#loading {
  bottom: 0;
  &.withTopBar {
    top: 1rem;
  }
}

#wrap {
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
